import * as React from "react";
import { SVGProps } from "react";

const HakkaFinance = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
    <path
      fill="#06803f"
      fillRule="evenodd"
      d="M21.9 8s0 .1-.1.1c-.2.8-2.5 5.2-3.3 6l-.1.1-.8.8 4.4 2.1c-2.5 2.9-6.4 4.8-10.9 4.8S2.7 20 .2 17.1l-.2-.2L4.2 15l-.4-.4-.5-.4C2.7 13.7.5 9.4.2 8.3l-.1-.1c1.3.9 4.9 1.8 9.2 2h2.9c4.3-.2 7.7-1 9.2-1.9l.1-.1.4-.2zM5 11l.3 1c.2.6.4 1.2.6 1.7l.2.4.5.9c.1.1.1.2.2.3l.1.1.4.3c.7.4 1.4.8 2.3 1l.3.1.9.2h.5l.9-.2c.9-.2 1.6-.5 2.3-.9l.3-.2.4-.3c.1-.1.2-.2.2-.3l.1-.1.5-.9c.3-.6.5-1.1.7-1.7l.1-.5.2-.9c-.6 1.1-1.7 1.8-3 2h-.4c-1-.1-1.9-.7-2.4-1.5l-.1-.2H11l-.1.2c-.5.8-1.4 1.3-2.4 1.5h-.6c-1.3-.1-2.4-.9-2.9-2zm6-11c.8 0 1.9.6 3.5 1.9l.2.2.7.6 1.9 1.6 1.3.4c.2.1.4.1.6.2l.4.1h.3l.4.1.2.1.2.1c.9.3 1.3.7 1.3 1.2v.2l-.1.1-.1.1c-1.4 1-5 1.9-9.4 2.1H9.8C5.2 8.8 1.5 7.9.1 6.9 0 6.8 0 6.6 0 6.5c0-.6.5-1 1.5-1.4-.2-.2-.2-.3-.4-.5.3-.3.8-.6 1.2-.7.8-.1 1.3.1 1.8.2-.4-.2-1.2-1-1.4-1.3-.4-.8-.1-1.4.1-1.7V1l.1-.1.1-.1h.1c.2 0 1 0 1.3.3.6.9.5 1.9.8 2.4.2-.5.1-1 .5-1.6C6 1.2 7.2.4 8.1.6c0 .3.2.5.1.9C9.4.5 10.3 0 11 0z"
      clipRule="evenodd"
    />
  </svg>
);

export default HakkaFinance;
